import { StatusEnum } from './enums'

/**状态 */
export const STATUS_ENUM_MAP = new Map([
  [StatusEnum.Enable, '正常'],
  [StatusEnum.Disable, '已停用'],
])
